<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="3" class="heig-frame-child">
                    <gofix-card title="Service Category" class="contractTree contractPropertyAria" fullContent>
                        <template slot="gofixCard:right_header">
                            <b-button class="mr-3" v-if="$checkRole($accessModule.service_category_master, 'delete')" @click="removeNode">
                                <div class="tooltip">Delete</div>
                                <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0" />
                                </svg>
                            </b-button>
                            <b-button class="mr-3" v-if="$checkRole($accessModule.service_category_master, 'create')" @click="addChildNode">
                                <div class="tooltip">Create</div>
                                <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                    <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z" />
                                    <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z" />
                                </svg>
                            </b-button>
                            <b-dropdown v-if="$checkRole($accessModule.service_category_master, 'create')" class="btn" right v-b-tooltip.hover title="Setting">
                                <b-dropdown-item @click="$bvModal.show('modal-Import')" href="javascript:void(0)">Import</b-dropdown-item>
                                <b-modal :no-close-on-backdrop="true" @hide="hiddenModalImport" title="import file" ref="modal-Import" id="modal-Import" hide-footer>
                                    <b-form>
                                        <b-form-group>
                                            <b-form-file @input="chaneFile" :state="isCheckImport" ref="file-input" accept=".csv" v-model="fileImport">
                                                <template slot="file-name" slot-scope="{ names }">
                                                    <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                                                </template>
                                            </b-form-file>
                                        </b-form-group>
                                        <b-button-group class="d-block text-right">
                                            <gofix-button label="SUBMIT" @click="uploadFileImport" :loading="isActionImport" noBorder></gofix-button>
                                        </b-button-group>
                                    </b-form>
                                </b-modal>
                                <b-dropdown-item href="#">Export</b-dropdown-item>
                            </b-dropdown>
                        </template>
                        <div class="contenAbsolute">
                            <div class="tree-view-properties">
                                <tree ref="tree" :data="treeData" :options="opts" @node:clicked="select">
                                    <div slot-scope="{ node }" class="node-container"> {{ node.text }} </div>
                                </tree>
                            </div>
                        </div>
                    </gofix-card>
                </b-col>
                <b-col md="9" class="heig-frame-child pl-16">
                    <gofix-card class="mb-0 heig-frame-child" classContent="pl-25 pr-25">
                        <div class="title sm mb-0 pt-15 pb-20">{{breadCrumb}}</div>
                        <b-form class="pb-20 formCategory">
                            <gofix-form-tree 
                                label="Parent" 
                                :options="dataparents" 
                                v-model="nodeParent" 
                                :normalizer="normalizer" 
                                :loadOptions="loadOptions" 
                                search-nested />
                            <gofix-form-input 
                                label="Name" 
                                desc="Name of the categoty" 
                                v-model="name" />
                            <gofix-form-input 
                                label="Abbreviation" 
                                v-model="abbreviation" />
                            <div v-if="$checkRole($accessModule.service_category_master, 'create')">
                                <gofix-button 
                                    class="mr-3" 
                                    label="Save" 
                                    @click="save" 
                                    :loading="isAction" 
                                    :disabled="!nodeSelected || $disabledCreateOrUpdate(this.nodeSelected, $accessModule.service_category)" />
                                <gofix-button 
                                    label="CANCEL" 
                                    @click="refresEdit" 
                                    :disabled="!nodeSelected" 
                                    noBorder />
                            </div>
                        </b-form>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="remove.open">
            <div class="d-flex justify-content-center">
                <span class="center max-width-175">Are you sure you want to delete <strong>This Item?</strong></span>
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="remove.open = false">No</b-button>
                <b-button class="custom-btn" :disabled="remove.loading" @click="removeNodeAction">
                    <b-spinner v-if="remove.loading" small type="grow"></b-spinner> Yes
                </b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
import { LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect'
const simulateAsyncOperation = fn => {
    setTimeout(fn, 500)
}
import { mapGetters } from 'vuex';
import LiquorTree from 'liquor-tree'
export default {
    name: 'setting-master-service-category',
    components: {
        [LiquorTree.name]: LiquorTree
    },
    data() {
        return {
            remove: {
                open: false,
                loading: false,
            },
            treeData: this.getData(),
            nodeSelected: {},
            opts: {
                minFetchDelay: 500,
                fetchData: (node) => {
                    node.isBatch = false;
                    if (node.data.id == this.rootId) {
                        return new Promise((resolve, reject) => {
                            resolve([]);
                        });
                    }
                    return new Promise((resolve, reject) => {
                        if (!node.children.length) {
                            global.axios(`/api/master/tree-service-categories/${node.data.id}`, {
                                    method: "GET",
                                    data: {},
                                    headers: {
                                        Accept: "application/json",
                                    }
                                })
                                .then(response => {
                                    resolve(response.data.data);
                                })
                                .catch(error => reject(error));
                        } else {
                            resolve([]);
                        }
                    });
                }
            },
            isRoot: true,
            nodeId: '',
            rootId: 0,
            name: '',
            abbreviation: '',
            dataparents: [],
            nodeParent: null,
            nodeParentModal: null,
            replace: function(key, value) {
                switch (key) {
                    case "children":
                        if (value.length > 0) {
                            return value;
                        } else {
                            return null;
                        }
                        break;
                    default:
                        return value;
                }
            },
            isCheck: false,
            breadCrumb: '',
            isCheckImport: '',
            fileImport: null,
            isAction: false,
            isLoading: true,
            isActionImport: false,
            fileName: 'Click Browse to upload file'
        }
    },
    mounted() {
        // this.$refs.tree.$on('tree:mounted', (data) => {
        //     this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON() ? this.$refs.tree.toJSON() : [], this.replace));
        // })
        // this.$refs.tree.$on('tree:data:received', (data) => {
        //     this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
        // })
        // this.$refs.tree.$on('node:selected', (data) => {
        //     this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
        // })
    },
    watch: {
        fileImport: function(val, old) {
            if (val) {
                let arrExtionsionAccept = ['csv']
                let extensionArray = val.name.split('.');
                let extension = extensionArray[extensionArray.length - 1].toLowerCase();
                if (!arrExtionsionAccept.includes(extension)) {
                    this.$refs['file-input'].reset()
                    return this.$alertNotification("File format is incorrect. Please select a .csv file!", "primary");
                }
                return this.fileName = val.name;
            }
            return this.fileName = 'Click Browse to upload file'
        },
    },
    methods: {
        normalizer(node) {
            if (node.data.isBatch)
                return {
                    isDisabled: this.nodeSelected && this.nodeSelected.data && (this.nodeSelected.data.id == node.data.id) ? true : false,
                    id: node.data.id,
                    label: node.text,
                    children: node.children
                }
            return {
                isDisabled: this.nodeSelected && this.nodeSelected.data && (this.nodeSelected.data.id == node.data.id) ? true : false,
                id: node.data.id,
                label: node.text,
                children: undefined
            }
        },
        addChildNode() {
            if (!this.rootId && !this.isCheck) {
                let nodeNew = this.$refs.tree.append({
                    data: {
                        parent_id: null,
                        node_type: null,
                        status: false
                    },
                    text: 'New node',
                    state: {
                        selected: true
                    }
                })
                this.nodeSelected = nodeNew;
                this.isCheck = true;
                return;
            } else
            if (this.nodeSelected && !this.isCheck) {
                if (this.nodeSelected.enabled()) {
                    this.nodeSelected.expand();
                    var nodeNew = this.nodeSelected.append({
                        data: {
                            parent_id: this.nodeSelected.data.id,
                            node_type: null,
                            status: false
                        },
                        text: 'New node',
                        state: {
                            selected: true
                        }
                    });

                    this.isCheck = true;
                    this.isRoot  = false;

                    this.nodeParent = this.nodeSelected.data.id;
                    this.nodeParentModal = this.nodeSelected.data.id;

                    this.name = 'New node';
                    this.abbreviation = '';
                    this.nodeSelected = nodeNew;
                    this.nodeId = nodeNew.id;
                }
            }
        },
        getData() {
            return new Promise((resolve, reject) => {
                global.axios(`api/master/tree-service-categories/0`, {
                        method: "GET",
                        data: {},
                        headers: {
                            Accept: "application/json",
                        }
                    })
                    .then(response => {
                        this.isLoading = false;
                        if (response.data.data.length)
                            this.rootId = response.data.data[0].data.id;
                        else
                            this.rootId = 0
                        this.dataparents = response.data.data
                        resolve(response.data.data);
                    })
                    .catch(error => reject(error));
            });
        },
        async select(node) {
            if (!node.data.parent_id) {
                let ServiceCategoryInfo = await global.axios(`/api/master/service-categories/${node.data.id}`, {
                    method: "GET",
                    data: {},
                    headers: {
                        Accept: "application/json",
                    }
                });
                delete ServiceCategoryInfo.data.data.children;
                node.data = ServiceCategoryInfo.data.data
            }

            this.nodeSelected = node;
            this.nodeParent = node.data.parent_id;
            this.nodeParentModal = node.data.parent_id;
            this.name = node.data.text;
            this.abbreviation = node.data.abbreviation;
            node.data.id == this.rootId ? this.isRoot = true : this.isRoot = false;
            this.breadCrumb = 'N/a';
            if (node.data.id)
                this.breadCrumb = node.data.breadcrumb + ' >> ' + node.data.name;
            if (this.isRoot)
                this.breadCrumb = node.data.name;
            this.dataparents = JSON.parse(JSON.stringify(this.dataparents));
        },
        loadOptions({
            action,
            parentNode,
            callback
        }) {
            if (action === LOAD_CHILDREN_OPTIONS) {
                if (parentNode.children) {
                    parentNode.children = parentNode.children;
                    callback();
                    return
                };
                if (parentNode.data.isBatch) {
                    global.axios(`api/contracts/65/tree-service-categories/${parentNode.data.id}`, {
                            method: "GET",
                            data: {},
                            headers: {
                                Accept: "application/json",
                            }
                        })
                        .then(result => {
                            simulateAsyncOperation(() => {
                                parentNode.children = result.data.data
                                callback();
                            })
                        })
                } else {
                    parentNode.children = []
                    callback();
                }
            }
        },
        save() {

            if ( this.$checkRole(this.$accessModule.service_category_master, 'update') == false ) {
                return this.$alertNotification("You don't have permission", "danger");
            }

            if (!this.rootId) {
                return this.saveFirst();
            }
            if (!this.nodeParent && !this.isRoot)
                return this.$alertNotification("Parent is a required field", "danger");
            if (!this.name)
                return this.$alertNotification("Name is a required field", "danger");
            if (this.abbreviation) {
                this.abbreviation = this.abbreviation.trim();
            }
            if (this.isAction) return
            this.isAction = true
            this.nameA = this.name.trim();
            let data = {
                name: this.name,
                abbreviation: this.abbreviation,
                parent_id: this.nodeParent,
                node_type: "Service Category",
            }
            if (this.nodeSelected.data.status == false) {
                this.$store.dispatch(`ServiveCategoryMasterController/saveServiveCategory`, data)
                    .then(result => {
                        this.isAction = false;
                        this.isCheck = false;
                        result.data.data.text = this.name;
                        delete result.data.data.children;
                        this.nodeSelected.data = result.data.data;
                        this.isCheck = false;
                        this.$alertNotification(this.$notificationV2('adding', 'service_category'));
                        let nodeParent = this.$refs.tree.find({
                            data: {
                                id: result.data.data.parent_id
                            }
                        })
                        if (this.nodeParentModal != result.data.data.parent_id) {
                            const nodeOld = this.nodeSelected;
                            this.nodeSelected.remove();
                            if (nodeParent && !nodeParent[0].isBatch) {
                                nodeParent[0].append(nodeOld);
                            }
                        }
                        if (nodeParent) {
                            let node = this.$refs.tree.selected()
                            node.unselect();
                            nodeParent[0].data.isBatch = true;
                            nodeParent.select(true)
                            this.nodeSelected = nodeParent[0];
                            this.select(nodeParent[0]);
                            this.nodeSelected.expand();
                        } else this.nodeSelected = null;
                        this.dataparents = response.data.data
                        return;
                    })
                return
            }
            data.id = this.nodeSelected.data.id;
            this.$store.dispatch('ServiveCategoryMasterController/updateServiveCategory', data)
                .then(result => {
                    this.isAction = false;
                    let nodeParent = this.$refs.tree.find({
                        data: {
                            id: result.data.data.parent_id
                        }
                    })
                    const dataNode = {
                        id: result.data.data.id,
                        type: result.data.data.type,
                        parent_id: result.data.data.parent_id,
                        name: result.data.data.name,
                        text: result.data.data.name,
                        node_type: result.data.data.node_type,
                        isBatch: result.data.data.isBatch,
                        breadcrumb: result.data.data.breadcrumb,
                        abbreviation: result.data.data.abbreviation,
                    };
                    this.nodeSelected.data = dataNode;
                    if (this.nodeParentModal != result.data.data.parent_id) {
                        const nodeOld = this.nodeSelected;
                        this.nodeSelected.remove();
                        if (nodeParent && !nodeParent[0].isBatch) {
                            nodeParent[0].data.isBatch = true;
                            this.nodeParentModal = nodeParent[0].data.id;
                            this.nodeParent = nodeParent[0].data.id;
                            this.nodeSelected = nodeParent[0].append(nodeOld);
                            this.nodeSelected.expand();
                        } else this.nodeSelected = null;
                    }
                    this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
                    this.breadCrumb = result.data.data.breadcrumb + ' >> ' + result.data.data.name;
                    this.$alertNotification(this.$notificationV2('editing', 'service_category'));
                })
        },
        removeNodeAction() {
            if (this.nodeSelected) {
                if (this.nodeSelected.id == this.nodeId) {
                    this.isCheck = false;
                }
                if (this.nodeSelected.data.id != this.rootId) {
                    if (this.nodeSelected.data.status != false)
                        this.$store.dispatch('ServiveCategoryMasterController/removeServiveCategory', {
                            id: this.nodeSelected.data.id,
                        })
                    this.nodeSelected.remove();
                    let nodeParent = this.$refs.tree.find({
                        data: {
                            id: this.nodeSelected.data.parent_id
                        }
                    })
                    if (nodeParent[0].children.length == 0) {
                        nodeParent[0].data.isBatch = false;
                    }
                    this.nodeParent = null;
                    this.breadCrumb = ''
                    this.$alertNotification(this.$notificationV2('deleting', 'service_category'));
                    this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
                    this.remove.loading = false;
                    this.remove.open = false;
                    this.refreshData();
                } else {
                    this.remove.loading = false;
                    this.remove.open = false;
                    this.$alertNotification("Can't delete Root", "danger");
                }
            }
        },
        removeNode() {
            if (this.nodeSelected) {
                this.remove.open = true;
            }
        },
        refreshData() {
            this.nodeSelected = null
            this.name = '';
            this.abbreviation = ''
        },
        refresEdit() {
            if (this.nodeSelected) {
                this.name = this.nodeSelected.data.name
                this.abbreviation = this.nodeSelected.data.abbreviation,
                this.nodeParent = this.nodeSelected.data.parent_id;
            }
        },
        hiddenModalImport() {
            this.fileImport = null;
            this.isCheckImport = '';
        },
        refreshServiceCategory() {
            this.isLoading = true;
            global.axios(`api/master/tree-service-categories/0`, {
                    method: "GET",
                    data: {},
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(response => {
                    this.isLoading = false;
                    this.rootId = response.data.data[0].data.id;
                    this.nodeSelected = null
                    this.isRoot = true
                    this.name = ''
                    this.isCheck = false;
                    this.$refs.tree.tree.setModel(response.data.data);
                })
                .catch(error => {
                    this.isLoading = false;
                });
        },
        chaneFile(file) {
            this.isCheckImport = file ? true : false;
        },
        saveFirst() {
            if (this.isAction) return
            this.isAction = true
            let data = {
                name: this.name,
                abbreviation: this.abbreviation,
                parent_id: 0,
                node_type: "Service Category",
            };
            this.$store.dispatch(`ServiveCategoryMasterController/saveFirst`, data)
                .then(result => {
                    this.isAction = false
                    this.rootId = result.data.data.id
                    this.isCheck = false;
                    this.$refs.tree.setModel(result.data.data);
                    let nodeParent = this.$refs.tree.find({
                        data: {
                            id: result.data.data.id
                        }
                    })
                    nodeParent.select(true);
                    this.nodeSelected = nodeParent[0];
                    this.nodeSelected.expand();
                    this.select(this.nodeSelected);
                    this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
                })

        },
        uploadFileImport() {
            if (!this.fileImport) {
                return this.$alertNotification("Please choose file to import", "danger");
            }
            this.isActionImport = true;
            this.$store.dispatch(`ServiveCategoryController/uploadFileServiceCategory`, {
                    contract_id: 0,
                    fileServiceCategory: this.fileImport,
                    is_master: true
                })
                .then(result => {
                    this.$refs['modal-Import'].hide()
                    this.refreshServiceCategory();
                    this.isActionImport = false;
                    this.breadCrumb = '';
                    this.$alertNotification(this.$notificationV2('importing', 'service_category'));
                })
                .catch(error => {
                    this.isActionImport = false;
                    this.$alertNotification("File format is incorrect. Please select a .csv file!", "danger");
                })
        },
    }
}
</script>